module.exports = __webpack_public_path__ + "img/man_small.ef6d671e.svg";